<script lang="ts">
    export let webp: string | null = null;
    export let png: string | null = null;
    export let jpg: string | null = null;
    export let svg: string | null = null;
    export let alt: string;
    export let title: string | null = null;
    export let loading: 'eager' | 'lazy' | null | undefined = 'lazy';
    export let pictureClass: string | null = null;

    let className: string | null = null;
    export { className as class };
</script>

<picture class={pictureClass}>
    {#if webp != null}
        <source type="image/webp" srcset={webp} />
    {/if}
    {#if png != null}
        <source type="image/png" srcset={png} />
    {/if}
    {#if jpg != null}
        <source type="image/jpeg" srcset={jpg} />
    {/if}
    {#if svg != null}
        <source type="image/svg+xml" srcset={svg} />
    {/if}
    <img
        {loading}
        class={className}
        {alt}
        {title}
        src={png ?? jpg ?? svg}
        {...$$restProps}
    />
</picture>
